<template>
  <div class="tags-wrapper">
    <Tag v-for="(tag, index) in tags" :key="index" :tag="tag" :tagTemplate="tagTemplate[tag.tagType]" />
  </div>
</template>

<script>
import Tag from "../../../universal.features/tags/Tag.component";
import { TagMainObject } from "../../../../global_constants/tagMainObject";

export default {
  name: "OrdersTags.container",
  components: { Tag },
  props: {
    showTagPopup: {
      type: Object,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    tagSector:{
      type: String,
      required: true
    }
  },
  data(){
    return{
      tagTemplate: TagMainObject[this.tagSector]
    }
  },
  mounted(){
  }
};
</script>

<style scoped>
.tags-wrapper {
  display: flex;
}
</style>
